import React, { useState } from "react";
import { observer } from "mobx-react-lite";

import styles from "./showableComponent.module.scss";
import { Flex } from "@fluentui/react-northstar";
import { ShowMoreButton } from "../showMoreButton/ShowMoreButton";

export interface ShowableComponentProps {
    title: string | undefined;
    node: React.ReactNode;
}

export const ShowableComponent: React.FC<ShowableComponentProps> = observer((props) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Flex column hAlign="start">
            <ShowMoreButton
                titleShowMore={props.title}
                titleHide={props.title}
                onClickExpand={() => {
                    setIsExpanded(true);
                }}
                onClickHide={() => {
                    setIsExpanded(false);
                }}
            />
            {isExpanded && <div className={styles.nodeContainer}>{props.node}</div>}
        </Flex>
    );
});
